export const SELECTION_FILL_VALID = '#2196f3';
export const SELECTION_FILL_INVALID = '#8a8a8a';
export const SELECTION_FILLOPACITY = 0.2;
export const SELECTION_STROKE = '#3b82f6';
export const SELECTION_STROKEWIDTH = 2;
export const SELECTION_STROKEOPACITY = 1;
export const SELECTION_LINEDASH = [4, 4];
